/**
 * Los colores con los que se puede pintar el icono de un agente o de una
 * herramienta.
 *
 * Son DATO, no estilo: el usuario elige uno y se guarda con el agente. Por eso
 * no son tokens de estado —un icono morado no significa «ojo con esto»— y por
 * eso viven aqui, en un fichero que no pinta nada, igual que la paleta de las
 * etiquetas.
 *
 * Estaban escritos dos veces, en `AgentVisualEditor` y en `ToolForm`, con
 * listas parecidas pero no iguales. Y el 2026-09-12 una pasada automatica de
 * color se los llevo por delante en uno de los dos: siete opciones distintas
 * quedaron en cuatro con duplicados, porque un mapeo a tokens no distingue un
 * color que decora de un color que el usuario eligio. De ahi que esten aqui.
 */
/* eslint-disable no-restricted-syntax -- paleta de eleccion del usuario: es dato, no estilo */
export const COLORES_DE_ICONO = [
  { texto: '', fondo: 'bg-muted' },
  { texto: 'text-blue-500', fondo: 'bg-blue-500' },
  { texto: 'text-green-500', fondo: 'bg-green-500' },
  { texto: 'text-amber-500', fondo: 'bg-amber-500' },
  { texto: 'text-violet-500', fondo: 'bg-violet-500' },
  { texto: 'text-rose-500', fondo: 'bg-rose-500' },
  { texto: 'text-sky-500', fondo: 'bg-sky-500' },
  { texto: 'text-emerald-500', fondo: 'bg-emerald-500' },
]
/* eslint-enable no-restricted-syntax */

/** Los iconos entre los que se puede elegir. */
export const ICONOS_DISPONIBLES = [
  'bot', 'filter', 'phone', 'globe', 'star', 'zap', 'bell', 'message',
  'user', 'users', 'hash', 'check', 'search', 'settings', 'shield',
] as const

/** Y los emoji a mano, para quien prefiera uno. */
export const EMOJIS_RAPIDOS = ['🤖', '🧠', '🏠', '📞', '⚡', '✨', '🛠️', '🔎', '📈', '💬', '🧭', '🎯']
